<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" viewBox="0 0 18 18">
  <g clip-path="url(#a)">
    <path d="M13.35 2.1C12 1.567 10.395 1.5 9 1.5c-1.395 0-3 .067-4.35.6-2.003.78-3.15 2.437-3.15 4.545V16.5h15V6.645c0-2.107-1.148-3.765-3.15-4.545ZM6.878 15l1.124-1.125h1.995L11.123 15H6.878Zm-1.62-4.5V6.75h7.5v3.75h-7.5Zm7.117 1.5c0 .412-.338.75-.75.75a.752.752 0 0 1-.75-.75c0-.412.338-.75.75-.75s.75.338.75.75Zm-6-.75c.412 0 .75.338.75.75s-.338.75-.75.75a.752.752 0 0 1-.75-.75c0-.412.338-.75.75-.75ZM15 15h-2.625v-.285l-.863-.87a2.234 2.234 0 0 0 1.988-2.22V6.75c0-1.973-2.25-2.25-4.5-2.25s-4.5.277-4.5 2.25v4.875c0 1.155.87 2.092 1.987 2.22l-.862.87V15H3V6.645c0-1.5.757-2.587 2.197-3.15C6.308 3.06 7.74 3 9 3c1.26 0 2.693.06 3.803.495 1.44.563 2.197 1.65 2.197 3.15V15Z"/>
  </g>
  <defs>
    <clipPath id="a">
      <path d="M0 0h18v18H0z"/>
    </clipPath>
  </defs>
</svg>
